import { useLanguage } from '../../context/LanguageContext';

export default function LangToggle() {
  const { lang, setLang } = useLanguage();

  const toggleLang = () => {
    setLang((prev) => (prev === 'en' ? 'pt' : 'en'));
  };

  return (
    <button onClick={toggleLang} title="Language toggle" className="px-4 text-gray font-semibold text-l">
      {lang === 'pt' ? 'EN' : 'PT'}
    </button>
  );
}
